export const replaceTrailingPreviewElement = (str) => str.replace(/preview\/(authDenied|authFailed)/g, '').replace(/\/$/, '');
